import React from "react";
import AppButton from "./AppButton";
import AppInput from "./AppInput";
import AppToolbar from "./AppToolbar";
import AppTooltip from "./AppTooltip";

function ToolbarActionButton({ action, fallbackVariant = "muted" }) {
  if (!action) {
    return null;
  }

  const {
    label,
    ariaLabel,
    icon = null,
    variant = fallbackVariant,
    size = "md",
    iconOnly = false,
    onClick,
    disabled,
    tooltip,
    buttonProps = {},
  } = action;
  const resolvedIconOnly = Boolean(iconOnly);

  if (!label && !ariaLabel) {
    return null;
  }

  const button = (
    <AppButton
      variant={variant}
      size={size}
      iconOnly={resolvedIconOnly}
      aria-label={resolvedIconOnly ? ariaLabel || label : ariaLabel}
      onClick={onClick}
      disabled={disabled}
      {...buttonProps}
    >
      {icon}
      {resolvedIconOnly ? null : label}
    </AppButton>
  );

  return resolvedIconOnly ? (
    <AppTooltip content={tooltip || label || ariaLabel}>
      {button}
    </AppTooltip>
  ) : button;
}

function RenderAction({ action, variant }) {
  if (!action) {
    return null;
  }

  return <ToolbarActionButton action={action} fallbackVariant={variant} />;
}

export default function AppTableToolbar({
  className = "",
  search = null,
  utilityActions = [],
  secondaryAction = null,
  primaryAction = null,
}) {
  const normalizedSearch = search
    ? {
        placeholder: "Suchen",
        value: undefined,
        defaultValue: "",
        onChange: undefined,
        clearable: true,
        inputProps: {},
        ...search,
      }
    : null;

  const hasLeftContent = normalizedSearch || utilityActions.length > 0;
  const hasRightContent = Boolean(secondaryAction || primaryAction);

  return (
    <AppToolbar
      className={["ds-table-toolbar", className].filter(Boolean).join(" ")}
      left={
        hasLeftContent ? (
          <>
            {normalizedSearch ? (
              <div className="ds-table-toolbar__search">
                <AppInput
                  type="search"
                  size="md"
                  clearable={normalizedSearch.clearable}
                  value={normalizedSearch.value}
                  defaultValue={normalizedSearch.defaultValue}
                  onChange={normalizedSearch.onChange}
                  placeholder={normalizedSearch.placeholder}
                  {...normalizedSearch.inputProps}
                />
              </div>
            ) : null}
            {utilityActions.map((action, index) => (
              <ToolbarActionButton key={`${action.label || action.ariaLabel || "action"}-${index}`} action={action} />
            ))}
          </>
        ) : null
      }
      right={
        hasRightContent ? (
          <>
            <RenderAction action={secondaryAction} variant="outlined" />
            <RenderAction action={primaryAction} variant="primary" />
          </>
        ) : null
      }
    />
  );
}
